import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input} from '../form';
import {resetPassword} from '../../api/'

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop, token } = this.props;
    this.setState({isProcessing: true, serverError: null});

    resetPassword(token, model.password1)
      .then(() => {
        this.setState({isProcessing: false, serverError: null});
        onSuccess(model);
      })
      .catch((e) => {
        this.setState({isProcessing: false, serverError: e.message});
        onError(e.message);
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() } >
        <Input name="password1"
               type="password"
               label="New Password"
               icon="key"
               showErrors={showErrors}
               inputSize="pt-large"
               required />
        <Input name="password2"
               label="New Password Repeat"
               icon="key"
               type="password"
               showErrors={showErrors}
               inputSize="pt-large"
               required />
        {serverError && (
          <div className="pt-callout pt-intent-danger s4">
            {serverError}
          </div>
        )}
        {!isProcessing ? (
          <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
        ) : (
          <button type="submit" className="pt-button pt-disabled pt-large pt-icon-log-in">Submitting...</button>
        )}
      </Formsy>
    );
  }
}

export default ResetPasswordForm;


// WEBPACK FOOTER //
// ./src/components/forms/ResetPasswordForm.js